"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDummySignature = void 0;
const getDummySignature = async (_userOperation) => {
    return "0xfffffffffffffffffffffffffffffff0000000000000000000000000000000007aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa1c";
};
exports.getDummySignature = getDummySignature;
//# sourceMappingURL=getDummySignature.js.map